import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { IMAGES, ISNHCP_TEXT } from "../data/content";

export default function ISNHCPPage() {
  return (
    <>
      <SEO
        title="ISNHCP Uddannelsen"
        description="Læs om ISNHCP uddannelsen (Institute for the Study of Natural Horse Care Practices), De 4 søjler, The Wild Horse Model og certificeret hovtrimning."
      />

      {/* Header Banner */}
      <section className="bg-forest-900 text-white py-14 lg:py-18 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,format=auto,quality=80/assets/811d3c72-b547-489f-a70d-a64fabca8eaa/image00010_3.jpeg"
            alt="ISNHCP uddannelse og hovanatomi"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-400">
            Faglig Certificering & Metode
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-sand-50">
            Om uddannelsen ISNHCP
          </h1>
          <p className="text-sand-200 max-w-2xl text-base leading-relaxed">
            {ISNHCP_TEXT.sub}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-sand-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-7 space-y-4">
              <span className="text-xs font-bold uppercase tracking-wider text-earth-700">
                Uddannelsens grundlag
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-forest-900 leading-snug">
                {ISNHCP_TEXT.title}
              </h2>
              <p className="text-lg font-semibold text-forest-800">
                {ISNHCP_TEXT.sub}
              </p>
              <p className="text-charcoal-700 leading-relaxed text-base">
                {ISNHCP_TEXT.intro}
              </p>
            </div>

            <div className="md:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-sand-300 shadow-md">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,format=auto,quality=80/assets/811d3c72-b547-489f-a70d-a64fabca8eaa/image00010_3.jpeg"
                  alt="ISNHCP hovanatomi og trim"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>

          {/* Information Boxes: De 4 Søjler */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-forest-900">
                {ISNHCP_TEXT.pillarsTitle}
              </h3>
              <p className="text-charcoal-700 text-sm sm:text-base mt-1">
                {ISNHCP_TEXT.pillarsIntro}
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {ISNHCP_TEXT.pillars.map((pillar, idx) => (
                <div key={idx} className="bg-white p-6 rounded-2xl border border-sand-300 shadow-2xs space-y-3">
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-forest-100 text-forest-900 text-xs font-bold">
                    <i className="fa-solid fa-layer-group text-emerald-700"></i> Søjle {idx + 1}
                  </div>
                  <h4 className="text-lg font-bold text-forest-900">{pillar.name}</h4>
                  <p className="text-sm text-charcoal-700 leading-relaxed">
                    <strong>{pillar.name}</strong> {pillar.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Hvad har de vilde at gøre med vores tamme heste? */}
          <div className="bg-white p-8 rounded-2xl border border-sand-300 shadow-xs space-y-5">
            <h3 className="text-2xl font-bold text-forest-900">
              {ISNHCP_TEXT.wildHeader}
            </h3>

            <p className="text-charcoal-700 leading-relaxed text-base">
              {ISNHCP_TEXT.wildBody1}
            </p>

            <p className="text-charcoal-700 leading-relaxed text-base">
              {ISNHCP_TEXT.wildBody2}
            </p>

            <div className="pt-3 border-t border-sand-200">
              <p className="text-sm font-bold text-forest-900">
                {ISNHCP_TEXT.footerNote}
              </p>
            </div>
          </div>

          {/* Special Infobox */}
          <div className="bg-forest-900 text-white p-8 rounded-2xl border border-forest-800 shadow-md space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-emerald-500/20 text-emerald-400 flex items-center justify-center text-lg font-bold">
                <i className="fa-solid fa-certificate"></i>
              </div>
              <h3 className="text-xl font-bold text-sand-50">ISNHCP Certificeringsgaranti</h3>
            </div>
            <p className="text-sm text-sand-200 leading-relaxed">
              Som certificeret Natural Horse Care Practitioner har jeg gennemgået både teoretisk og praktisk uddannelse, som sikrer din hest en naturlig og faglig funderet behandling.
            </p>
          </div>

          {/* CTA Link */}
          <div className="text-center pt-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl bg-forest-900 hover:bg-forest-800 text-white font-bold text-sm transition-colors cursor-pointer"
            >
              <i className="fa-solid fa-calendar-check text-emerald-400"></i>
              <span>Book tid / Kontakt mig for rådgivning</span>
            </Link>
          </div>

        </div>
      </section>
    </>
  );
}
